export { ElectricIcon } from "./electric";
